module.exports = __webpack_public_path__ + "static/media/quickstart-step-8.a5e32fcc.jpg";